import React from 'react'
import Email from './subcomponents/Email'
import Phone from 'modules/User/Profile/subcomponents/Phone'
import { useTranslation } from 'react-i18next'
import { Typography } from 'gu-ui-kit'
import { Form, reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import validator from 'utils/asyncValidator'
import { validationSchema } from 'modules/Forms/Auth/Registration/validationSchema'
import PropTypes from 'prop-types'

let Profile = ({ handleSubmit, form, autofill, submitting }) => {
  const { t } = useTranslation()

  const submit = async (/*values, dispatch*/) => {
    /*console.log(values)*/
  }

  return (
    <>
      <Typography
        component={'h3'}
        variant={'Subtitle-25'}
        className={'margin-bottom-16'}
      >
        {t('user::settings.profile.auth_fields')}
      </Typography>
      <Form onSubmit={handleSubmit(submit)} noValidate>
        <div className={'margin-bottom-16'}>
          <Email />
        </div>
        <div>
          <Phone {...{ form, autofill, submitting }} />
        </div>
      </Form>
    </>
  )
}

Profile = reduxForm({
  form: 'ProfileForm',
  updateUnregisteredFields: true,
  enableReinitialize: true,
  initialValues: {
    email: '',
    country_code: '',
    phone_mask: '',
    phone: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(validationSchema),
})(Profile)

Profile.propTypes = {
  onSuccess: PropTypes.func,
  handleSubmit: PropTypes.func,
  autofill: PropTypes.func,
  submitting: PropTypes.bool,
  form: PropTypes.string,
}

export default Profile
